/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Step/view.blocks to change it.
import Display from './Display/index'
import React from 'react'
import Reference from './Reference/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Step({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/Step"
  
}) {
  return (<React.Fragment
>
<Reference
  viewPath={`${viewPath}/Reference`}
/>
<div
  data-testid="Step.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Display
  viewPath={`${viewPath}/Display`}
/>
</div>
{children}
</React.Fragment>)
}